import { CalculationResult } from '../utils/calculator';
const baseUrl = 'https://life-plus.health/assets/';
const emailTemplate = `<!DOCTYPE html>
<html lang="he" dir="rtl">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <title>מחשבון הוספת שנות חיים - כללית</title>
    <style type="text/css">
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700&display=swap');
        body, table, td, p, a, li, blockquote { -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }
        table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; }
        img { -ms-interpolation-mode: bicubic; border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
        body { direction: rtl; text-align: right; font-family: 'Open Sans', Arial, Helvetica, sans-serif; }
        @media only screen and (max-width: 600px) {
            .mobile-hide { display: none !important; }
            .mobile-center { text-align: center !important; }
            .mobile-padding { padding: 20px !important; }
            .mobile-font-size { font-size: 14px !important; }
            .email-container { width: 100% !important; max-width: 100% !important; padding: 10px !important; }
            .card-container { width: 100% !important; max-width: 100% !important; margin: 10px 0 !important; }
            .header-image { width: 100% !important; max-width: 100% !important; height: auto !important; }
            .content-padding { padding: 20px !important; }
            .mobile-title { font-size: 18px !important; }
            .mobile-text { font-size: 13px !important; line-height: 1.5 !important; }
            .mobile-small-text { font-size: 11px !important; line-height: 1.4 !important; }
            .content-image { width: 100% !important; height: 180px !important; object-fit: cover !important; }
            .mobile-list { padding-right: 15px !important; }
            .mobile-margin-bottom { margin-bottom: 20px !important; }
            .mobile-section-margin { margin-bottom: 40px !important; }
        }
        @media only screen and (max-width: 360px) {
            .email-container { padding: 5px !important; }
            .content-padding { padding: 15px !important; }
            .mobile-title { font-size: 16px !important; }
            .mobile-text { font-size: 12px !important; }
            .mobile-small-text { font-size: 10px !important; }
            .content-image { height: 150px !important; }
            .mobile-section-margin { margin-bottom: 30px !important; }
        }
    </style>
</head>
<body style="margin: 0; padding: 0; background-color: #f7fbfb; direction: rtl;">
    <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%" style="background-color: #f7fbfb;">
        <tr>
            <td align="center" style="padding: 20px 0;" class="email-container">
                <img src="${baseUrl}header.png" alt="חיים פלוס" style="display: block; margin: 0 auto; max-width: 600px; width: 100%;" class="header-image" />
                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width: 600px; background-color: #ffffff; border-radius: 20px; box-shadow: 0px 3px 4px 0px rgba(108,218,222,0.1); margin-top: 20px;" class="card-container">
                    <tr>
                        <td style="padding: 32px;" class="content-padding">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                <tr>
                                    <td>
                                        <p style="margin: 0 0 8px 0; color: #333333; font-size: 16px; line-height: 1.4;" dir="rtl" class="mobile-text">
                                            שלום, [FULL_NAME].
                                        </p>
                                        <p style="margin: 0 0 30px 0; color: #333333; font-size: 16px; line-height: 1.4;" dir="rtl" class="mobile-text">
                                            להלן תוצאות מחשבון הוספת שנות חיים והמלצות לאורח חיים בריא יותר.
                                        </p>

                                        <div style="background-color: rgba(232,246,246,0.5); border-radius: 16px; padding: 16px; margin-bottom: 16px;">
                                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                                <tr>
                                                    <td>
                                                        <p style="margin: 0 0 15px 0; color: #333333; font-size: 14px;" class="mobile-text">
                                                            הפרמטרים שהוזנו במחשבון:
                                                        </p>
                                                        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                                            <tr>
                                                                <td style="padding: 4px 0;">
                                                                    <span style="color: #333333; font-size: 12px; font-weight: bold;" dir="rtl" class="mobile-small-text">גיל</span>
                                                                    <span style="color: #333333; font-size: 12px; margin-right: 4px;" class="mobile-small-text">[AGE]</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="padding: 4px 0;">
                                                                    <span style="color: #333333; font-size: 12px; font-weight: bold;" dir="rtl" class="mobile-small-text">עישון</span>
                                                                    <span style="color: #333333; font-size: 12px; margin-right: 4px;" class="mobile-small-text">[SMOKE]</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="padding: 4px 0;">
                                                                    <span style="color: #333333; font-size: 12px; font-weight: bold;" dir="rtl" class="mobile-small-text">לחץ דם סיסטולי</span>
                                                                    <span style="color: #333333; font-size: 12px; margin-right: 4px;" class="mobile-small-text">[SYS_BLOOD_PRESSURE]</span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td style="padding: 4px 0;">
                                                                    <span style="color: #333333; font-size: 12px; font-weight: bold;" dir="rtl" class="mobile-small-text">כולסטרול (Non-HDL)</span>
                                                                    <span style="color: #333333; font-size: 12px; margin-right: 4px;" class="mobile-small-text">[CHOLESTEROL]</span>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <div style="background-color: rgba(232,246,246,0.5); border-radius: 16px; padding: 16px;">
                                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                                <tr>
                                                    <td>
                                                        [TOTAL_YEARS_SECTION]
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>

                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width: 600px; background-color: #ffffff; border-radius: 20px; box-shadow: 0px 3px 4px 0px rgba(108,218,222,0.1); margin-top: 20px;" class="card-container">
                    <tr>
                        <td style="padding: 32px;" class="content-padding">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                <tr>
                                    <td>
                                        [CHOLESTEROL_RECOMMENDATION_SECTION]
                                        [BP_RECOMMENDATION_SECTION]
                                        [SMOKE_RECOMMENDATION_SECTION]

                                        <div>
                                            <h2 style="margin: 0 0 24px 0; color: #333333; font-size: 20px; font-weight: bold; text-align: right;" dir="rtl" class="mobile-title">
                                                פעילות גופנית
                                            </h2>
                                            <img src="${baseUrl}activity.png" alt="פעילות גופנית" style="width: 100%; height: 240px; object-fit: cover; border-radius: 16px; margin-bottom: 24px;" class="content-image" />
                                            <div style="margin-bottom: 16px;">
                                                <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
                                                    הגיע הזמן לקחת שליטה על הבריאות שלך. הכלי החזק ביותר להארכת חיים הוא
                                                    פעילות גופנית. כנראה כבר שמעת שפעילות גופנית טובה ללב שלך – אבל האם
                                                    אתה יודע איזו פעילות נכונה עבורך?
                                                </p>

                                                <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
                                                    פעילות אירובית היא כל פעילות שמעלה את הדופק – למשל הליכה מהירה,
                                                    ריצה, שחייה, רכיבה על אופניים, אירובי, ריקוד, זומבה, הייקינג בטבע,
                                                    ואפילו אימון פונקציונלי.<br>
                                                    כדי שהפעילות תתרום לבריאות הלב, חשוב להגיע לדופק של 70-90% מהדופק
                                                    המרבי, אותו ניתן לחשב לפי נוסחה פשוטה:
                                                </p>

                                                <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px; font-weight: 600;">
                                                    220 פחות הגיל שלך = דופק מרבי.
                                                </p>

                                                <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
                                                    אגב, אם בא לך להעמיק בזה קצת יותר, ולחשב בצורה מדויקת יותר את דופק
                                                    המטרה שלך, הנה מחשבון אמין, לפי נוסחת קרוונן:
                                                    <a href="https://www.calculator.net/target-heart-rate-calculator.html" style="color: #0066cc; text-decoration: underline; font-weight: bold;">https://www.calculator.net/target-heart-rate-calculator.html</a>
                                                </p>

                                                <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
                                                    <span style="font-weight: 600;">ומה לגבי פעילות
                                                        אנאירובית?</span><br>
                                                    מתמקדת בחיזוק ובניית השרירים – הרמת משקולות, סקווטים, פלאנקים,
                                                    שכיבות סמיכה, פילאטיס מכשירים, יוגה דינאמית, קרוספיט, TRX וכמובן
                                                    עבודת מכשירים בחדר הכושר. השרירים בגופנו אינם רק ליציבה ולכוח –
                                                    בניית שריר גם תורמת לאיזון רמות הסוכר, שיפור חילוף החומרים, ושימור
                                                    מסת גוף רזה בתהליך של ירידה במשקל. בלי פעילות כזו, אם אתה בתהליך של
                                                    הרזיה אינטנסיבית, ייתכן שתאבד גם שריר – וזה משהו שחשוב להימנע ממנו.
                                                </p>

                                                <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
                                                    אם אתה מרגיש שחשוב לך להכניס גם יותר רוגע לחיים לחוצים…פעילויות כמו
                                                    יוגה, טאי צ'י, פילאטיס ופלדנקרייז תורמות לגמישות, יציבה טובה יותר,
                                                    שחרור מתחים ושיפור הקשב לגוף – ומשלימות את התמונה הכוללת של בריאות
                                                    גופנית ונפשית.
                                                </p>
                                            </div>
                                            <a href="https://mushlam.clalit.co.il/he/content_worlds/active/Pages/default.aspx" target="_blank" style="color: #0066cc; font-size: 12px; text-decoration: underline; font-weight: bold;">לחצו להורדת אפליקצית כללית אקטיב.</a>
                                        </div>

                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>

                <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="600" style="max-width: 600px; margin-top: 20px;" class="card-container">
                    <tr>
                        <td style="padding: 20px 0;">
                            <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                                <tr>
                                    <td>
                                        <p style="margin: 0 0 16px 0; color: #666666; font-size: 11px; line-height: 18px;" dir="rtl" class="mobile-small-text">
                                            קבלת את המייל כיוון שנרשמת לקבלת המלצות מותאמות אישיות.
                                        </p>
                                        <p style="margin: 0; color: #666666; font-size: 11px; line-height: 18px;" dir="rtl" class="mobile-small-text">
                                            המערכת הינה בגרסה ניסיונות ואינה מיועדת להחליף ייעוץ מקצועי, דיאגנוזה רפואית
                                            או טיפול. המידע המתקבל משימוש במערכת מתקבל ״כפי שהוא״ ללא כל אחריות או תמיכה
                                            ומפעילי המערכת ומפתחיה לא יהיו אחראיים לשום נזק ישיר או עקיף. השימוש במערכת
                                            יתבצע באחריות המשתמש בלבד. הנתונים מבוססים על ה-LIFE-CVD model. המודל פותח
                                            עבור מטופלים ללא היסטוריה של מחלה קרדיווסקולרית ידועה, שבץ, צנתורים, אי
                                            ספיקת כליות, פרפור פרוזדורים או אי-ספיקת לב.
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
</html>`;

const allZeroTemplate = `<div style="text-align: center; padding: 20px 0;">
    <img src="${baseUrl}thumbs.png" alt="כל הכבוד" style="display: block; margin: 0 auto 16px auto; width: 96px; height: 96px;" aria-hidden="true" />
    <p style="margin: 0; color: #333333; font-size: 16px; line-height: 1.4;" dir="rtl" class="mobile-text">כל הכבוד! המדדים שלך תקינים.</p>
</div>`;

const normalTotalYearsTemplate = `<p style="margin: 0 0 15px 0; color: #333333; font-size: 14px;" dir="rtl" class="mobile-text">
    <span>רווח השנים הפוטנציאלי: </span>
    <span style="color: #006574; font-weight: bold;">[TOTAL_YEARS_TEXT]</span>
</p>

<table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
    [BP_YEARS_RESULT]
    [CHOL_YEARS_RESULT]
    [SMOKE_YEARS_RESULT]
</table>`;

const bpYearsTemplate = `<tr>
    <td style="padding: 4px 0;">
        <span style="color: #333333; font-size: 12px; font-weight: bold;" dir="rtl" class="mobile-small-text">לחץ דם</span>
        <span style="color: #333333; font-size: 12px; margin-right: 4px;" dir="rtl" class="mobile-small-text">
            רווח השנים הפוטנציאלי הוא <span style="color: #006574; font-weight: bold;">[BP_YEARS_TEXT]</span> לאחר איזון לחץ הדם.
        </span>
    </td>
</tr>`;

const cholYearsTemplate = `<tr>
    <td style="padding: 4px 0;">
        <span style="color: #333333; font-size: 12px; font-weight: bold;" dir="rtl" class="mobile-small-text">כולסטרול</span>
        <span style="color: #333333; font-size: 12px; margin-right: 4px;" dir="rtl" class="mobile-small-text">
            רווח השנים הפוטנציאלי הוא <span style="color: #006574; font-weight: bold;">[CHOL_YEARS_TEXT]</span> לאחר איזון רמות הכולסטרול.
        </span>
    </td>
</tr>`;

const smokeYearsTemplate = `<tr>
    <td style="padding: 4px 0;">
        <span style="color: #333333; font-size: 12px; font-weight: bold;" dir="rtl" class="mobile-small-text">עישון</span>
        <span style="color: #333333; font-size: 12px; margin-right: 4px;" dir="rtl" class="mobile-small-text">
            רווח השנים הפוטנציאלי הוא <span style="color: #006574; font-weight: bold;">[SMOKE_YEARS_TEXT]</span> לאחר הפסקת עישון.
        </span>
    </td>
</tr>`;

const cholesterolRecommendationTemplate = `<!-- Cholesterol Reduction Section -->
<div style="margin-bottom: 64px;" class="mobile-section-margin">
    <h2 style="margin: 0 0 24px 0; color: #333333; font-size: 20px; font-weight: bold; text-align: right;" dir="rtl" class="mobile-title">
        הפחתת כולסטרול
    </h2>
    <img src="${baseUrl}colesterol.png" alt="תזונה ים-תיכונית" style="width: 100%; height: 240px; object-fit: cover; border-radius: 16px; margin-bottom: 24px;" class="content-image" />
    <div style="margin-bottom: 16px;">
        <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl" class="mobile-text">
            <span style="font-weight: 600;">תזונה ים-תיכונית</span><br>
            תזונה בריאה ללב לא חייבת להיות קפדנית או מונוטונית – להיפך. התזונה הים-תיכונית היא טעימה, מגוונת, ומשלבת מזונות טבעיים שמוכחים מדעית כמפחיתי סיכון לטרשת עורקים ולמחלות לב.<br>
            העיקרון פשוט: יותר מזון מהצומח, פחות שומן רווי מהחי. מומלץ למלא את הצלחת ב:
        </p>
        <ul style="margin: 0 0 16px 0; padding-right: 18px; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl" class="mobile-list mobile-text">
            <li style="margin-bottom: 4px;">ירקות ופירות טריים בכל צבעי הקשת</li>
            <li style="margin-bottom: 4px;">דגנים מלאים (כמו קינואה, בורגול, אורז מלא, שיבולת שועל)</li>
            <li style="margin-bottom: 4px;">קטניות (עדשים, חומוס, שעועית)</li>
            <li style="margin-bottom: 4px;">אגוזים וזרעים (בכמות מתונה)</li>
            <li style="margin-bottom: 4px;">עוף (ללא עור), צלוי או מבושל</li>
            <li style="margin-bottom: 4px;">שמן זית – כמקור שומן עיקרי</li>
            <li>דגים (בעיקר עשירים באומגה-3 כמו סלמון, טונה, סרדינים, מקרל).<br>
                שונא דגים..? שווה לשאול את הרופא שלך האם הוא ממליץ לך לקחת תיסוף
                של אומגה 3<br>
                (בדרך כלל מומלץ למי שיש טריגליצרידים גבוהים בנוסף לכולסטרול)
            </li>
        </ul>

        <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl" class="mobile-text">
            <span style="font-weight: 600;">ומה להפחית?</span><br>
            מזונות עתירי שומן רווי וכולסטרול – בשר אדום, נקניקים, גבינות שמנות,
            חמאה, מזון מעובד.
        </p>
    </div>
    <div style="background-color: #f3fafa; border-radius: 16px; padding: 16px;">
        <p style="margin: 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl" class="mobile-text">
            חשוב לציין שלפעמים לא די בתזונה ופעילות גופנית, במיוחד כשהכולסטרול הגבוה הוא תורשתי.<br>
            במקרה כזה - טיפול תרופתי הוא חיוני. כדאי להתייעץ עם הרופא בנושא הזה,
            כי כיום כבר ברור בנוגע לכולסטרול - כמה שיותר נמוך, וכמה שיותר מוקדם
            - יותר טוב!<br>
            ודרך אגב, גם אם אתה חווה תופעות לוואי עם טיפול תרופתי - אתה לא
            לבד!<br>
            פנה לרופא שלך ותבקש תחליף. יש כיום המון טיפולים אפשריים להפחתת
            כולסטרול ולכל סיר יש מכסה.
        </p>
    </div>
</div>`;

const bpRecommendationTemplate = `<!-- Blood Pressure Reduction Section -->
<div style="margin-bottom: 64px;" class="mobile-section-margin">
    <h2 style="margin: 0 0 24px 0; color: #333333; font-size: 20px; font-weight: bold; text-align: right;" dir="rtl" class="mobile-title">
        הפחתת לחץ דם
    </h2>
    <img src="${baseUrl}blood_pressure.png" alt="הפחתת מלח" style="width: 100%; height: 240px; object-fit: cover; border-radius: 16px; margin-bottom: 24px;" class="content-image" />
    <div style="margin-bottom: 16px;">
        <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
            <span style="font-weight: 600;">פחות מלח – יותר בריאות!</span><br>
            הגוף שלך צריך רק כמות קטנה מאוד של נתרן כדי לתפקד – אבל רוב האנשים
            צורכים פי שניים ואף יותר מהמומלץ. עודף מלח בתזונה עלול להעלות את לחץ
            הדם ולפגוע בלב, בכליות ובכלי הדם.
        </p>

        <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
            איך מפחיתים?<br>
            זה לא רק מה שמוסיפים – אלא מה שמתחבא. מרבית צריכת המלח שלנו מגיעה
            דווקא ממזונות מעובדים, קפואים או מוכנים מראש – ולא מהמלח שאתה שם
            ביד.
        </p>

        <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
            כמה צעדים פשוטים לתזונה דלת מלח:
        </p>
        <ul style="margin: 0 0 16px 0; padding-right: 18px; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
            <li style="margin-bottom: 4px;">העדף מזון טרי וביתי במקום קפואים,
                מוכנים או משומרים</li>
            <li style="margin-bottom: 4px;">בחר מוצרים עם סימון "ללא תוספת נתרן"
                או "דל נתרן"</li>
            <li style="margin-bottom: 4px;">תבלינים כמו שום, לימון, כמון,
                פפריקה, בזיליקום ואורגנו ישדרגו את הטעם בלי להוסיף נתרן</li>
            <li style="margin-bottom: 4px;">שטוף מזון משומר (טונה, תירס, זיתים)
                כדי להפחית נתרן עודף</li>
            <li>צמצם צריכת מאפים תעשייתיים, חטיפים, נקניקים, גבינות מלוחות
                ומרקים מוכנים</li>
        </ul>
    </div>
    <div style="background-color: #f3fafa; border-radius: 16px; padding: 16px;">
        <p style="margin: 0; color: #333333; font-size: 12px; line-height: 22px;">
            זכור: הפחתת צריכת מלח היא אחת הדרכים היעילות להורדת לחץ דם – גם בלי
            תרופות.<br>
            עם זאת - לעיתים אין מנוס מטיפול תרופתי. כדאי לדון עם הרופא שלך בנוגע
            לנחיצות טיפול תרופתי להפחתת לחץ דם, ואם הוא רשם לך תרופות - חשוב
            להתמיד. כיום קיימים טיפולים משולבים שמשלבים שני תכשירים בכדור אחד,
            פתרון יעיל ונוח.
        </p>
    </div>
</div>`;

const smokeRecommendationTemplate = `<!-- Smoking Cessation Section -->
<div style="margin-bottom: 64px;" class="mobile-section-margin">
    <h2 style="margin: 0 0 24px 0; color: #333333; font-size: 20px; font-weight: bold; text-align: right;" dir="rtl" class="mobile-title">
        הפסקת עישון
    </h2>
    <img src="${baseUrl}somking-free.png" alt="הפסקת עישון" style="width: 100%; height: 240px; object-fit: cover; border-radius: 16px; margin-bottom: 24px;" class="content-image" />
    <div style="margin-bottom: 16px;">
        <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
            <span style="font-weight: 600;">זה הרגע לכבות – ולהרוויח את החיים שלך בחזרה!</span><br>
            עישון הוא אחד מגורמי הסיכון המרכזיים למחלות לב וכלי דם, והוא מזרז
            התפתחות של טרשת עורקים, מעלה את לחץ הדם, פוגע בזרימת הדם ללב – ואף
            מקצר את תוחלת החיים בכמה שנים טובות.<br>
            וזה מבלי לדבר על תחלואות אחרות שנגרמות מעישון. אבל אין ספק שכבר שמעת
            הכל בעבר.
        </p>

        <p style="margin: 0 0 16px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
            הנה החדשות הטובות: הפסקת עישון מביאה תועלת כמעט מיידית.<br>
            כבר בתוך 20 דקות מדחיית הסיגריה – לחץ הדם יורד. תוך כמה ימים –
            משתפרת הנשימה. ותוך שנה – הסיכון לאירוע לבבי יורד כמעט בחצי.
        </p>
    </div>
    <div style="background-color: #e0fcff; border-radius: 16px; padding: 16px; margin-bottom: 16px;">
        <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
            <tr>
                <td style="width: 42px; vertical-align: top; padding-left: 16px;">
                    <img src="${baseUrl}smoking-icon.png" alt="אייקון עישון" style="width: 42px; height: 42px;" />
                </td>
                <td style="vertical-align: top;">
                    <p style="margin: 0 0 4px 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
                        כמו כל שינוי משמעותי – גם הפסקת עישון היא תהליך. אין
                        צורך לעשות את זה לבד.
                    </p>
                    <a href="https://workshop-cloud.clalit.co.il/home" target="_blank" style="color: #0066cc; font-size: 12px; text-decoration: underline;">למידע על סדנאות גמילה מעישון בקופת חולים כללית – לחצו כאן</a>
                </td>
            </tr>
        </table>
    </div>

    <p style="margin: 0; color: #333333; font-size: 12px; line-height: 22px;" dir="rtl">
        <span style="font-weight: 600;">ומה עם תרופות?</span><br>
        אם אתה מרגיש שניסית הכל וזה לא הולך, דבר עם הרופא שלך בנוגע לאופציות
        לעזרה תרופתית בתהליך<br>
        הפסקת העישון.
    </p>
</div>`;

function formatYearsWithMonths(val: number) {
    const years = Math.floor(val);
    const months = Math.round((val % 1) * 12);
    if (years === 0 && months === 0) return '0';
    if (months === 0) return `${years}`;
    // return decimal so the small template will show e.g. "3.2 שנים"
    // we choose one decimal (months -> .1 = ~1.2 months not perfect but readable)
    return (val).toFixed(1);
}

function getYearText(years: number): string {
    if (years === 0) return '';
    if (years === 1) return 'שנה';
    if (years === 2) return 'שנתיים';
    return `${years} שנים`;
}

function getMonthText(months: number): { number: string; text: string } {
    if (months === 0) return { number: '', text: '' };
    if (months === 1) return { number: 'חודש אחד', text: '' };
    if (months === 2) return { number: 'חודשיים', text: '' };
    return { number: `${months}`, text: ' חודשים' };
}

function formatTotalYears(years: number, months: number): string {
    const hasYears = years > 0;
    const hasMonths = months > 0;

    if (hasYears && hasMonths) {
        const yearText = getYearText(years);
        const monthData = getMonthText(months);
        const connector = months === 2 ? 'ו' : 'ו-';
        return `${yearText} ${connector}${monthData.number}${monthData.text}`;
    } else if (hasYears) {
        return getYearText(years);
    } else if (hasMonths) {
        const monthData = getMonthText(months);
        return monthData.number + monthData.text;
    } else {
        return '0 שנים';
    }
}

function yearsTextForPhrase(val: number) {
    // returns a human readable Hebrew phrase matching ResultsPage format
    const years = Math.floor(val);
    const months = Math.round((val % 1) * 12);

    if (years === 0 && months === 0) {
        return '0 שנים';
    }

    const yearText = getYearText(years);

    if (months > 0) {
        const monthData = getMonthText(months);
        const monthText = monthData.number + monthData.text;
        if (yearText) {
            // For 2 months (חודשיים), don't use dash after ו
            const connector = months === 2 ? 'ו' : 'ו-';
            return `${yearText} ${connector}${monthText}`;
        } else {
            return monthText;
        }
    }

    return yearText;
}

export function generateEmailHtml(result: CalculationResult, userName: string): string {
    // input data expected shape based on existing code: result.input_data.{age, smoking, systolic, cholesterol}
    const input = (result as any).input_data || {};
    const age = input.age ?? '';
    const smoking = input.smoking === 'yes' ? 'מעשן' : 'לא מעשן';
    const systolic = input.systolic ?? '';
    const cholesterol = input.cholesterol ?? '';
    const totalYears = typeof result.total_years === 'number' ? Math.max(0, result.total_years) : 0;
    const totalYearsInt = Math.floor(totalYears);
    const totalYearsMonths = Math.round((totalYears % 1) * 12);
    const totalYearsText = formatTotalYears(totalYearsInt, totalYearsMonths);

    // interventions
    const bpIntervention = (result.interventions || []).find((i: any) => i.type === 'systolic') || { years: 0 };
    const cholIntervention = (result.interventions || []).find((i: any) => i.type === 'cholesterol') || { years: 0 };
    const smokeIntervention = (result.interventions || []).find((i: any) => i.type === 'smoking') || { years: 0 };

    // Build recommendation rows only if years > 0
    let bpYearsResultHtml = '';
    let cholYearsResultHtml = '';
    let smokeYearsResultHtml = '';
    let bpRecommendationHtml = '';
    let cholRecommendationHtml = '';
    let smokeRecommendationHtml = '';

    const bpYears = bpIntervention.years || 0;
    const cholYears = cholIntervention.years || 0;
    const smokeYears = smokeIntervention.years || 0;

    // Check if all interventions are zero and no smoking (allZero condition)
    const hasSystolic = bpYears > 0;
    const hasCholesterol = cholYears > 0;
    const hasSmoking = input.smoking === 'yes';
    const hasAnyIntervention = hasSystolic || hasCholesterol || hasSmoking;
    const allZero = !hasAnyIntervention && totalYearsInt === 0 && totalYearsMonths === 0;

    // Build intervention results first
    if (bpYears > 0) {
        const bpYearsText = yearsTextForPhrase(bpYears);
        bpYearsResultHtml = bpYearsTemplate.replace(/\[BP_YEARS_TEXT\]/g, bpYearsText);
        bpRecommendationHtml = bpRecommendationTemplate;
    }

    if (cholYears > 0) {
        const cholYearsText = yearsTextForPhrase(cholYears);
        cholYearsResultHtml = cholYearsTemplate.replace(/\[CHOL_YEARS_TEXT\]/g, cholYearsText);
        cholRecommendationHtml = cholesterolRecommendationTemplate;
    }

    if (input.smoking === 'yes' && smokeYears > 0) {
        const smokeYearsText = yearsTextForPhrase(smokeYears);
        smokeYearsResultHtml = smokeYearsTemplate.replace(/\[SMOKE_YEARS_TEXT\]/g, smokeYearsText);
        smokeRecommendationHtml = smokeRecommendationTemplate;
    }

    // Build total years section
    let totalYearsSectionHtml = '';
    if (allZero) {
        totalYearsSectionHtml = allZeroTemplate;
    } else {
        totalYearsSectionHtml = normalTotalYearsTemplate
            .replace(/\[TOTAL_YEARS_TEXT\]/g, totalYearsText)
            .replace(/\[BP_YEARS_RESULT\]/g, bpYearsResultHtml)
            .replace(/\[CHOL_YEARS_RESULT\]/g, cholYearsResultHtml)
            .replace(/\[SMOKE_YEARS_RESULT\]/g, smokeYearsResultHtml);
    }

    let html = emailTemplate
        .replace(/\[FULL_NAME\]/g, userName) // name not available on CalculationResult here
        .replace(/\[AGE\]/g, String(age))
        .replace(/\[SMOKE\]/g, String(smoking))
        .replace(/\[SYS_BLOOD_PRESSURE\]/g, String(systolic))
        .replace(/\[CHOLESTEROL\]/g, String(cholesterol))
        .replace(/\[CHOLESTEROL_RECOMMENDATION_SECTION\]/g, cholRecommendationHtml)
        .replace(/\[BP_RECOMMENDATION_SECTION\]/g, bpRecommendationHtml)
        .replace(/\[SMOKE_RECOMMENDATION_SECTION\]/g, smokeRecommendationHtml)
        .replace(/\[TOTAL_YEARS_SECTION\]/g, totalYearsSectionHtml);

    return html;
}